/**
 * drawer theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/drawer.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { drawerAnatomy } from '@chakra-ui/react/anatomy';
export const drawer = defineSlotRecipe({
    slots: drawerAnatomy.keys(),
    base: {
        backdrop: {
            bgColor: 'secondary.persianBlue/60',
        },
        closeTrigger: {
            position: 'absolute',
            top: '16px',
            insetEnd: '20px',
        },
        content: {
            backgroundColor: '{colors.background.offWhite}',
            border: '2px solid {colors.black}',
            borderBottomWidth: '0',
            roundedBottom: '0',
            roundedTop: '8px',
        },
        header: {
            textAlign: 'center',
            textStyle: 'body1Bold',
            pb: '0',
        },
        title: {
            textAlign: 'center',
            textStyle: 'body1Bold',
        },
        body: {
            px: '20px',
        },
        footer: {
            flexDirection: 'column',
            borderTopWidth: '2px',
            borderColor: 'black',
            py: '16px',
            px: '20px',
        },
    },
    variants: {
        size: {
            md: {
                content: {
                    w: '480px',
                },
            },
            full: {
                content: {
                    /**
                     * add some space at top of drag drawer
                     */
                    '&.drag-drawer-content': {
                        height: `calc(100dvh - 30px)`,
                    },
                    rounded: '0px',
                    roundedTop: '8px',
                },
            },
        },
        placement: {
            end: {
                content: {
                    rounded: '0px',
                    roundedStart: '8px',
                    borderBottomWidth: '2px',
                    borderEndWidth: '0',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {},
});
